import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { Second } from '@nu-art/ts-common';
import { Page_Advisor } from '../Page_Advisor/Page_Advisor.js';
import { Page_Advisor_Mini } from '../Page_Advisor_Mini/Page_Advisor_Mini.js';
import { ModuleFE_AdvisorBoard } from '../../../_enum.js';
import { dispatch_validateCache, EpicEvent_RequestToCloseApp, ModuleFE_AdvisorWindowMessenger, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Dialog_Recap } from '../../dialogs/Dialog_Recap/Dialog_Recap.js';
export class Page_AdvisorSwitcher extends ComponentSync {
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        state.mini = ModuleFE_AdvisorMini.getIsMiniActive();
        return state;
    }
    componentDidMount() {
        ModuleFE_AdvisorBoard.updateAdvisorMeasurements();
        if (ModuleFE_EMInterface.isAvatarMode())
            ModuleFE_AdvisorWindowMessenger.postAvatarLaunched();
        // initiate epic messenger
        ModuleFE_AdvisorWindowMessenger.initializeReceiver();
        ModuleFE_AdvisorWindowMessenger.initiateEpicHandshake({
            SubscriptionRequests: [{
                    EventName: EpicEvent_RequestToCloseApp,
                    EventArgs: { PauseDuration: Second }
                }]
        });
        // validate the cache - async, shouldn't be awaited
        dispatch_validateCache.dispatchAllAsync();
        Dialog_Recap.show();
    }
    //######################### Render #########################
    render() {
        if (this.state.mini)
            return _jsx(Page_Advisor_Mini, {});
        return _jsx(Page_Advisor, {});
    }
}
//# sourceMappingURL=Page_AdvisorSwitcher.js.map